import { render, staticRenderFns } from "./PasswordModification.vue?vue&type=template&id=cd865d4c&scoped=true"
import script from "./PasswordModification.ts?vue&type=script&lang=ts&external"
export * from "./PasswordModification.ts?vue&type=script&lang=ts&external"
import style0 from "./PasswordModification.scss?vue&type=style&index=0&id=cd865d4c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd865d4c",
  null
  
)

export default component.exports